



































































































import {
    Vue,
    Component,
    Prop,
} from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import { DidRow } from '@/api/dids';

@Component({ components: { Icon } })
export default class DidsInfoTable extends Vue {
    @Prop({ type: Array, default: () => [] }) readonly rows!: DidRow[];

    search = '';

    copiedDid: string | null = null;

    get filteredRows(): DidRow[] {
        const term = this.search.trim().toLowerCase();
        if (!term) return this.rows;

        return this.rows.filter((row) => {
            const did = (row.did || '').toLowerCase();
            const medio = (row.medio || '').toLowerCase();
            const producto = (row.producto || '').toLowerCase();
            return did.includes(term)
                || medio.includes(term)
                || producto.includes(term);
        });
    }

    // eslint-disable-next-line class-methods-use-this
    formatDid(did: string): string {
        if (!did) return '';
        const cleaned = did.replace(/\D/g, '');
        if (cleaned.length === 10) {
            return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        }
        if (cleaned.length === 11 && cleaned.startsWith('1')) {
            return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
        }
        return did;
    }

    copyToClipboard(did: string): void {
        navigator.clipboard.writeText(did).then(() => {
            this.copiedDid = did;
            setTimeout(() => {
                this.copiedDid = null;
            }, 2000);
        });
    }
}
